<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px" [formGroup]="form">
	<mat-form-field *ngIf="this.form.value.id !== 0">
		<input matInput placeholder="Job Number" formControlName="number" readonly
			matTooltip="This field is not editable" />
	</mat-form-field>
	<mat-form-field *ngIf="isFlairdocsJob">
		<input autocomplete="off" matInput readonly matTooltip="This field is not editable" maxlength="256"
			placeholder="Flairdocs Activity Id" formControlName="flairDocsJobId" />
	</mat-form-field>
	<rpshared-customer-link required formControlName="customer" readonly
		matTooltip="Customer cannot be changed after a job is approved"></rpshared-customer-link>
	<rpshared-railroad-link required readonly formControlName="railroad"
		matTooltip="Railroad cannot be changed after a job is approved"></rpshared-railroad-link>
	<rpshared-division-link formControlName="division" [divisions]="divisions$ | async"
		(optionSelected)="divisionSelected($event)"></rpshared-division-link>
	<rpshared-select-list required formControlName="regularTimeBasis" placeholder="Regular Time Basis"
		[items]="regularTimeBasisTypes"></rpshared-select-list>
	<div style="width: 100%; display: flex;">
		<rpshared-select-list required formControlName="overTimeBasis" placeholder="Overtime Basis" style="width: 95%;"
			[items]="overtimeBasisTypes"></rpshared-select-list>
		<div style="width: 5%;" matSuffix matTooltip="Update to match {{railroad?.code}}'s current Overtime Basis"
			*ngIf="isBillingOrAdminRole">
			<button style="width: 1.5em;" [disabled]="isOvertimeBasisMatchingRailroad$ | async" mat-button
				mat-icon-button si (click)="syncToRailroad()">
				<mat-icon style="height: 1.25em;padding-top: 85%;
				width: 1em;
				line-height: 1.25;
				font-size:16px !important;">refresh</mat-icon>
			</button>

		</div>
	</div>
	<rpshared-field-team-link formControlName="team"></rpshared-field-team-link>
	<rpshared-date-picker required formControlName="start" placeholder="Job start date"
		clearable></rpshared-date-picker>
	<rpshared-date-picker required formControlName="end" placeholder="Job end date" clearable></rpshared-date-picker>
	<rpshared-select-list required formControlName="party" placeholder="Party"
		[items]="jobPartyTypes"></rpshared-select-list>
	<rpshared-select-list required formControlName="jobType" placeholder="Type of Work" [items]="typesOfWork"
		[displayFunc]="displayJobType"></rpshared-select-list>
	<rpshared-select-list required formControlName="endMarket" placeholder="End Market" [items]="endMarket"
		[displayFunc]="displayEndMarket"></rpshared-select-list>
	<mat-form-field>
		<input autocomplete="off" matInput spellcheck="false" autocomplete="off" maxlength="3"
			placeholder="Days Requested (under scheduling fee)" formControlName="daysRequested" />
		<mat-error *ngIf="form.get('daysRequested').hasError('max')">
			Maximum value of 15.
		</mat-error>
		<mat-error *ngIf="form.get('daysRequested').hasError('min')">
			Must be a positive value.
		</mat-error>
		<mat-error *ngIf="form.get('daysRequested').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="off" matInput spellcheck="false" autocomplete="off" maxlength="30"
			placeholder="Permit Number" formControlName="permitNumber" />
	</mat-form-field>
	<mat-form-field>
		<mat-select formControlName="quoteStatus" disableOptionCentering="true" placeholder="Quote Status">
			<mat-option *ngFor="let status of quoteStatuses" [value]="status">
				{{ displayQuoteStatus[status] }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-slide-toggle formControlName="isSafetyTrainingComplete" labelPosition="before" class="custom-slider">Safety
		Training Complete
	</mat-slide-toggle>
	<mat-form-field>
		<input autocomplete="off" matInput maxlength="256" placeholder="Track Supervisor / Roadmaster"
			formControlName="trackSupervisor" />
	</mat-form-field>
	<mat-form-field>
		<mat-select (selectionChange)="offeredServiceChange($event)" placeholder="Offered Services"
			disableOptionCentering="true" [compareWith]="idComparer" multiple formControlName="offeredServices">
			<mat-option [class.red]="offeredService.isActive" *ngFor="let offeredService of offeredServices$ | async"
				[value]="offeredService">
				{{ displayName(offeredService) }}
				{{ offeredService.isActive ? '' : '(Inactive)' }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field *ngIf="showOrderNumber$ | async">
		<input autocomplete="off" matInput maxlength="256" placeholder="Order #" formControlName="orderNumber"
			[required]="showOrderNumber$ | async" />
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field *ngIf="showTrackID$ | async">
		<mat-select formControlName="trackID" disableOptionCentering="true" placeholder="Track ID"
			[required]="showTrackID$ | async">
			<mat-option *ngFor="let jobTrackID of jobTrackIDs" [value]="jobTrackID">
				{{ displayJobTrackID[jobTrackID] }}
			</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<input matInput autocomplete="off" placeholder="Description of Schedule"
			formControlName="descriptionOfSchedule" />
		<mat-hint>e.g. Mon - Fri, 8am - 6pm</mat-hint>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<input matInput autocomplete="off" placeholder="Equipment Description" formControlName="equipmentDescription" />
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<textarea matInput maxlength="100" required cdkTextareaAutosize cdkAutosizeMinRows="2" placeholder="Description"
			formControlName="description">
		</textarea>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" placeholder="Additional Job Details"
			formControlName="notes">
		</textarea>
	</mat-form-field>

	<rpshared-multi-chip-input gdColumn="1 / -1" placeholder="Send Dwr Approval Notifications To"
		[formControl]="form.get('dwrNotificationRecipients')" isEmailList="true"></rpshared-multi-chip-input>
	<mat-error *ngIf="form.get('dwrNotificationRecipients').hasError('hasInvalidEmails')">
		One or more invalid emails entered
	</mat-error>
</div>